var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import Location from './Location';
import ClassNames from './Location.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
* A basic location widget that can be wrapped by any application specific implementation to
* populate the location fields.
*/
var LocationWidget = /** @class */ (function (_super) {
    __extends(LocationWidget, _super);
    function LocationWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationWidget.prototype.getStyleObject = function () {
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { name: this.getElementInlineStyle('location'), address: this.getElementInlineStyle('address') });
    };
    LocationWidget.prototype.render = function () {
        var _a = this.props, location = _a.location, classes = _a.classes, _b = _a.address, address = _b === void 0 ? {} : _b, displayAddressOption = _a.config.displayAddressOption; // Remove sections of the address that will be ommitted for display
        var addressToDisplay = __assign({}, address);
        if (displayAddressOption === 'location') {
            addressToDisplay = undefined;
        }
        else if (displayAddressOption === 'locationAddress' && address) {
            addressToDisplay.countryCode = undefined;
            addressToDisplay.countryName = undefined;
        }
        return React.createElement(Location, __assign({}, resolveTestId(this.props), { classes: classes, style: this.getStyleObject(), location: location, address: addressToDisplay }));
    };
    LocationWidget.displayName = 'LocationWidget';
    LocationWidget.propTypes = {
        config: PropTypes.shape({
            displayAddressOption: PropTypes.string
        }),
        classes: PropTypes.object,
        style: PropTypes.object,
        translate: PropTypes.func,
        // Non-configurable appData props that should be added by the application specific wrapper.
        location: PropTypes.string,
        address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            address3: PropTypes.string,
            city: PropTypes.string,
            stateCode: PropTypes.string,
            postalCode: PropTypes.string,
            countryCode: PropTypes.string,
            countryName: PropTypes.string
        })
    };
    LocationWidget.defaultProps = {
        classes: ClassNames
    };
    return LocationWidget;
}(BaseWidget));
export default LocationWidget;
